import useCategoriesSelect from 'modules/categories/hooks/use-categories-select';
import {translatedCreateSubCategoryProps} from 'modules/sub-categories/hooks/use-create-sub-category';
import useEditSubCategory, {
  EditSubCategoryProps,
} from 'modules/sub-categories/hooks/use-edit-sub-category';
import SubCategoriesKeys from 'modules/sub-categories/util/sub-categories-keys';
import React from 'react';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

const EditCategory: React.FC = () => {
  const {id} = useParams();
  const {getInput, getSwitch, getSelect} =
    useFormInputs<EditSubCategoryProps>();

  const {data, isLoading} = useCategoriesSelect();

  return (
    <Edition<EditSubCategoryProps>
      titleBar={{title: 'Editar sub categoria'}}
      inputs={[
        getInput({
          name: 'name',
        }),
        getSelect({name: 'categoryId', data, isLoading}),
        getSwitch({
          name: 'active',
        }),
      ]}
      translationKey={translatedCreateSubCategoryProps}
      detailsUrl={`/sub-categories/${id}`}
      onSubmit={() => useEditSubCategory(id!)}
      queryKey={SubCategoriesKeys.details(id!)}
    />
  );
};

export default EditCategory;
